import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../environments/environment';

@Pipe({
  name: 'file',
})
export class FilePipe implements PipeTransform {
  url: string = environment.apiURL;

  transform(value: unknown, ...args: unknown[]): string {
    const raw = String(value ?? '');
    // basename + encode: niente JWT in query (documenti protetti → openProtectedFile)
    const [pathPart, query = ''] = raw.split('?');
    const name = pathPart.split(/[\\/]/).pop() || '';
    const q = query ? `?${query}` : '';
    return `${this.url}file/${encodeURIComponent(name)}${q}`;
  }
}
